const STORAGE_PREFIX = 'vspsafe:admin:'

export const StorageKeys = {
  LOGIN_INFO: 'loginInfo',
  SESSION_CHECK_TIME: 'lcsot',
  AUTO_SAVE_TEMPLATE: 'last-unsaved-template'
}

function prefixedKey(key) {
  return `${STORAGE_PREFIX}${key}`
}

export function storageGet(key) {
  return localStorage.getItem(prefixedKey(key))
}

export function storageSet(key, value) {
  localStorage.setItem(prefixedKey(key), value)
}

export function storageRemove(key) {
  localStorage.removeItem(prefixedKey(key))
}
